import { render } from "./user-card.vue?vue&type=template&id=737902e6&scoped=true"
import script from "./user-card.vue?vue&type=script&lang=js"
export * from "./user-card.vue?vue&type=script&lang=js"

import "./user-card.vue?vue&type=style&index=0&id=737902e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737902e6"]])

export default __exports__